module.exports = __webpack_public_path__ + "static/media/296420.79fab174.png";